<template>
	<div>
		<h1>{{ value.values.systolic_last }} {{ value.values.diastolic_last }} <small v-html="units"></small></h1>
		<p class="row">
			<b>{{ $t('labels.general.systolic') }} {{ $t('labels.general.min') }}</b>
			<span>{{ value.values.systolic_min }} <span v-html="units"></span></span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.systolic') }} {{ $t('labels.general.max') }}</b>
			<span>{{ value.values.systolic_max }} <span v-html="units"></span></span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.systolic') }} {{ $t('labels.general.average') }}</b>
			<span>{{ value.values.systolic_avg }} <span v-html="units"></span></span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.diastolic') }} {{ $t('labels.general.min') }}</b>
			<span>{{ value.values.diastolic_min }} <span v-html="units"></span></span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.diastolic') }} {{ $t('labels.general.max') }}</b>
			<span>{{ value.values.diastolic_max }} <span v-html="units"></span></span>
		</p>
		<p class="row">
			<b>{{ $t('labels.general.diastolic') }} {{ $t('labels.general.average') }}</b>
			<span>{{ value.values.diastolic_avg }} <span v-html="units"></span></span>
		</p>
		<!--pre>{{ value }}</pre-->
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'value'
	],
	computed: {
		units () {
			return Readings.readingTypes.get(parseInt(this.value.type_id)).unitHtml
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/modal/ModalBoxBiometricBloodPressure.vue